__turbopack_context__.v({
  "button": "WReferenceLinkingToUrlCtaPill-module__1C6r1W__button",
});
